import { h }                                           from 'preact';
import type { FunctionalComponent, ComponentChildren } from 'preact';
import { useEffect, useState }                         from 'preact/hooks';

type medalsJSON = {
	MedalTableInfo : null | {
		c_AsOfDate : string;
	};
	MedalTableNOC : MedalNOC[];
};

type MedalNOC = {
	n_NOCID : number;
	c_NOC : string;
	c_NOCShort : string;
	n_Gold : number;
	n_Silver : number;
	n_Bronze : number;
	n_Total : number;
	n_RankGold : number;
	n_RankSortGold : number;
	n_RankTotal : number;
	n_RankSortTotal : number;
};

type MedalsProps = {
	link : string;
	title : string;
	backgroundImage : string;
	logoTop : string;
	logoBottom : string;
	backgroundColor : string;
	medalsFeed : string;
	sortBy : 'Gold' | 'Total';
	displayCount : number;
}

const Medals : FunctionalComponent<MedalsProps> = ( props ) => {
	const [ medalsFeed, setMedalsFeed ] = useState<medalsJSON | undefined>( undefined );
	const [ loaded, setLoaded ] = useState<boolean | undefined>( undefined );

	useEffect( () => {
		fetch( props.medalsFeed, { cache : 'production' === process.env.NODE_ENV ? 'no-cache' : 'no-store' } ).then( res => res.json() ).then( ( result : medalsJSON ) => {
			setMedalsFeed( result );
			setLoaded( !!result.MedalTableInfo );
		} );

		return () => {
			// cleanup??
		};
	}, [] );

	if ( !loaded ) {
		return <div />;
	} else {
		return (
			<div style={{
				marginBottom : 0,
				fontSize     : 14,
				textAlign    : 'center',
				fontFamily   : 'Arial, sans-serif',
				color        : 'hsla(0, 0%, 0%, 0.8)',
			}}>
				<a id='nbcolympicscommedals_root' href={props.link} target='_blank' style={{
					position         : 'relative',
					backgroundColor  : props.backgroundColor,
					backgroundImage  : 'url(' + props.backgroundImage + ')',
					backgroundRepeat : 'no-repeat',
					backgroundSize   : 'cover',
					maxWidth         : 360,
					padding          : 12,
					boxSizing        : 'border-box',
					display          : 'flex',
					flexFlow         : 'row wrap',
					justifyContent   : 'center',
					alignItems       : 'center',
					margin           : '0 auto 3px',
					textDecoration   : 'none',
				}}>
					{!medalsFeed ? <div>Loading...</div> : <div style={{ marginBottom : 0 }}>
						<img style={{ marginBottom : 0, display : 'inline-block' }} src={props.logoTop} alt={props.title} />
						{medalsFeed.MedalTableNOC
						           .reduce<MedalNOC[]>( ( acc, item ) => {
							           if ( item.n_RankSortTotal <= props.displayCount ) {
								           acc.push( item );
							           }
							           return acc;
						           }, Array( props.displayCount ) )
						           .sort( ( a, b ) => ( a[ 'n_RankSort' + props.sortBy as keyof MedalNOC ] > b[ 'n_RankSort' + props.sortBy as keyof MedalNOC ] ) ? 1 : -1 )
						           .map( medals => {
							           return (
								           <div key={medals.n_NOCID} style={{
									           margin         : 12,
									           flex           : '1 0 150px',
									           display        : 'flex',
									           flexFlow       : 'row',
									           justifyContent : 'center',
									           alignItems     : 'center',
									           textAlign      : 'center',
									           border         : '2px solid white',
									           background     : 'linear-gradient( -45deg, #8AB5FF, #CAD5FA, #8AB5FF )'
								           }}>
									           <div style={{
										           marginBottom    : 0,
										           width           : 24,
										           height          : 24,
										           fontWeight      : 'bold',
										           fontSize        : 14,
										           lineHeight      : '24px',
										           flex            : '0 0 24px',
										           marginLeft      : '-18px',
										           marginRight     : '-3px',
										           backgroundColor : '#1550FB',
										           color           : '#FFFFFF',
										           border          : '2px solid white',
									           }}>
										           {medals.n_RankSortTotal}
									           </div>
									           <div style={{
										           marginBottom : 0,
										           flex         : '1 0 auto',
										           fontSize     : 18,
										           lineHeight   : '24px',
										           padding      : 12,
									           }}>
										           {medals.c_NOCShort}
									           </div>
									           <div style={{
										           marginBottom    : 0,
										           flex            : '1 0 auto',
										           fontSize        : 18,
										           lineHeight      : '24px',
										           backgroundColor : '#1550FB',
										           color           : '#FFFFFF',
										           padding         : 6,
										           borderLeft      : '2px solid white',
										           borderRight     : '2px solid white',
										           alignSelf       : 'stretch',
										           display         : 'flex',
										           flexFlow        : 'row wrap',
										           justifyContent  : 'center',
										           alignItems      : 'center',
										           fontWeight      : 'bold',
									           }}>
										           <div style={{
											           marginBottom : 0,
											           flex         : '1 0 100%',
											           fontSize     : 18,
											           lineHeight   : '24px',
										           }}>
											           <div style={{
												           marginBottom : 0,
												           fontSize     : 10,
												           lineHeight   : '10px',
											           }}>
												           TOTAL
											           </div>
											           {medals.n_Total}
										           </div>
									           </div>
									           <div style={{
										           marginBottom : 0,
										           display      : 'flex',
										           flexFlow     : 'row',
										           textAlign    : 'center',
										           fontSize     : 18,
										           fontWeight   : 'bold',
										           textShadow   : '0px 0px 3px hsla(55, 89%, 85%, 1)',
										           padding      : 12,
									           }}>
										           <MedalCount size={32} color='gold'>
											           {medals.n_Gold}
										           </MedalCount>
										           <MedalCount size={32} color='silver'>
											           {medals.n_Silver}
										           </MedalCount>
										           <MedalCount size={32} color='bronze'>
											           {medals.n_Bronze}
										           </MedalCount>
									           </div>
								           </div>
							           );
						           } )}
					</div>}
					<img style={{ marginBottom : 0, display : 'inline-block' }} src={props.logoBottom} alt={props.title} />
				</a>
				<a style={{ marginBottom : 0 }} href={props.link}>Full rankings</a>
			</div>
		);
	}
};

type MedalCountProps = {
	size : number;
	color : 'gold' | 'silver' | 'bronze';
	children? : ComponentChildren;
};

const MedalCount : FunctionalComponent<MedalCountProps> = ( { size, color, children } ) => {
	const gradients = {
		gold   : {
			topLeft     : [
				'#FFFFFF',
				'#FFFFAC',
				'#D1B464',
				'#5D4A1F',
				'#5D4A1F'
			],
			bottomRight : [
				'#FEDB37',
				'#FDB931',
				'#9F7928',
				'#8A6E2F',
			],
		},
		silver : {
			topLeft     : [
				'#FFFFFF',
				'#DEF6FF',
				'#93ABC4',
				'#727E8A',
				'#53585C'
			],
			bottomRight : [
				'#ABDADB',
				'#7E98A8',
				'#5E666E',
				'#4D5154',
			],
		},
		bronze : {
			topLeft     : [
				'#FFFFFF',
				'#D1B38A',
				'#A18760',
				'#5E503E',
				'#40382D'
			],
			bottomRight : [
				'#BA986C',
				'#A17F48',
				'#705A3F',
				'#554A3C',
			],
		},
	};

	return (
		<div style={{
			flex           : '1 0 auto',
			margin         : '0 3px',
			borderRadius   : '50%',
			width          : size,
			height         : size,
			padding        : 1,
			background     : `linear-gradient( 135deg, ${gradients[ color ].bottomRight.reverse().join( ',' )} )`,
			textShadow     : '0px 0px 4px hsla(0, 0%, 100%, .95)',
			display        : 'flex',
			flexFlow       : 'column',
			justifyContent : 'center',
			alignItems     : 'center',
			color          : 'hsla(0, 0%, 0%, 0.8)',
		}}>
			<div style={{
				marginBottom : 0,
				flex         : '1 0 auto',
				lineHeight   : `${size}px`,
				borderRadius : '50%',
				width        : '100%',
				background   : 'radial-gradient(ellipse farthest-corner at right bottom, ' +
				               gradients[ color ].bottomRight[ 0 ] +
				               ' 0%, ' +
				               gradients[ color ].bottomRight[ 1 ] +
				               ' 8%, ' +
				               gradients[ color ].bottomRight[ 2 ] +
				               ' 30%, ' +
				               gradients[ color ].bottomRight[ 3 ] +
				               ' 40%, transparent 80%),' +
				               'radial-gradient(ellipse farthest-corner at left top, ' +
				               gradients[ color ].topLeft[ 0 ] +
				               ' 0%, ' +
				               gradients[ color ].topLeft[ 1 ] +
				               ' 8%, ' +
				               gradients[ color ].topLeft[ 2 ] +
				               ' 25%, ' +
				               gradients[ color ].topLeft[ 3 ] +
				               ' 62.5%, ' +
				               gradients[ color ].topLeft[ 4 ] +
				               ' 100%)',
			}}>
				{/*<div style={{ margin : '0 auto', borderRadius : '50%', backgroundColor : 'hsla(0, 0%, 100%, 0.6)', width : 18, height : 18 }}>*/}
				{children}
				{/*</div>*/}
			</div>
		</div>
	);
};

export default Medals;